import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';

import List, { ListItem, ListItemIcon, ListItemText } from 'material-ui/List';
import { MenuList, MenuItem } from 'material-ui/Menu';

import Reboot from 'material-ui/Reboot';
import 'typeface-roboto';
import Table, { TableBody, TableCell, TableHead, TableRow } from 'material-ui/Table';

import TextField from 'material-ui/TextField';
import { ajaxPost } from '../ajax';
import Button from 'material-ui/Button';
import Typography from 'material-ui/Typography';
import { CircularProgress } from 'material-ui/Progress';
import green from 'material-ui/colors/green';
import Paper from 'material-ui/Paper';
import CardContent from 'material-ui/Card/CardContent';
import Card from 'material-ui/Card';

import LogoutIcon from 'material-ui-icons/ExitToApp'
import IconButton from 'material-ui/IconButton';
import Tooltip from 'material-ui/Tooltip';

import TimeEntries from './UserTimeEntries';
import ViewProfile from './ViewProfile';


var moment = require('moment');

const styles = theme => ({
  title:
    {
      margin: 20,
      flex: 1,
    },
    container: {
      display: 'block',
      margin: "130px 20px 20px 20px",
    },
    textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    marginTop: 15,
    width: 200,
  },
  button:
    {
      margin: 3,
      height: 16,
      width: 16,
    },
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  table: {
    marginTop: 20,
  },
  main:
    {
      margin: 10
    },
  fabProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -15,
    marginLeft: -15,
  },
  wrapper: {
    margin: theme.spacing.unit,
    position: 'relative',
    display: 'inline-flex',
  },
  select:
    {
      width: 500,
    },
  selectLabel:
    {
      fontSize: "10.5pt",
      marginBottom: 5,
    },
  calendar:
    {
      width: 100,
      borderRight: "1px solid lightgray",
      textAlign: "right",
      padding: "0px 5px 20px 0px",
      margin: 10,
    },
  divDate:
    {
      fontSize: "24pt",
      fontWeight: "bold",
      color: "navy",
      margin: 5
    },
  divDay:
    {

    },
  tdMessage: {
    borderBottom: "1px dotted lightgray",
    fontSize: "10pt",
    paddingBottom: 10,
  },
  tdEntries:
    {
      width: 100,
      paddingTop: 10,
      fontWeight: "bold",
    },
  divContents:
    {
      marginLeft: 20,
    },
  paper:
    {
      padding: 10,
    },
  logo:
    {
      marginTop: 10,
      height: 50,
    },
  header:
    {
      margin: 0,
      left: 0,
      top: 0,
      position: 'fixed',
      borderBottom:'1px solid darkgrey',
      backgroundColor: "white",
      width: "100%",
      zIndex: 1000,
      overflow:'visible',
      height:121,
    },
  toolbar:
    {
      display: 'inline-flex',
      width: "100%"
    },

  menuLine:
    {
      display: 'inline-flex',
      width: "100%"
    },
  cebgo:
    {
      marginTop: 16,
      height: 40,
      marginRight: 20,
      marginLeft: 20,
    },
  user:
    {
      float: "right",
      marginRight: 20,
      display: "inline-flex",
    },
  username:
    {
      marginTop: 5,
      marginRight: 10,
    },
    menu:
    {
      borderTop:'1px solid gray',
      borderLeft:'1px solid gray',
      borderRight:'1px solid gray',
      padding:10,
      height:24,

    },
    menuContainer:
    {
      position:'relative',
      marginLeft:10,
      width:130,
      background:'white',
      height:50,
      cursor:'pointer',
    },
    menu_back:
    {
      padding:10,
      height:24,
    },
    menu_back_container:
    {
      position:'relative',
      marginLeft:10,
      width:130,
      background:'white',
      height:40,
      cursor:'pointer',
     
    }


});


class UserModule extends Component {
  updateTab = (module) =>
  {
      this.setState({selected:module});
  }

  state =
    {
      selected:"time",
    }


  render() {
    const { classes } = this.props;
    return (
      <div>
        <div className={classes.header}>
          <div style={{ "backgroundColor": "#FCFB01", "height": "5px", "width": "100%" }}></div>
          <div className={classes.toolbar}>
            <Typography variant="headline" className={classes.title}>
              {"Crew TEMS"}
            </Typography>
            <div className={classes.user}>
              <div className={classes.username}>{global.userName}</div>
              <Tooltip id="tooltip-logout" title="Logout">
                <IconButton onClick={() => window.location = "Logout"} color="inherit" className={classes.button}>
                  <LogoutIcon />
                </IconButton>
              </Tooltip>
            </div>
          </div>
          <div className={classes.menuLine}>
          <div className={this.state.selected=='time' ? classes.menuContainer : classes.menu_back_container}
            onClick={this.updateTab.bind(this,'time')}
            >
            <div className={this.state.selected=='time' ? classes.menu : classes.menu_back}>
              Time Entries
            </div>
            </div>
            <div className={this.state.selected == 'profile' ? classes.menuContainer : classes.menu_back_container}
            onClick={this.updateTab.bind(this,'profile')}
            >
            <div className={this.state.selected == 'profile' ? classes.menu : classes.menu_back}
            >
              Profile
            </div>
            </div>
          </div>
        </div>
        <div className={classes.container}>
        { this.state.selected=='time' && <TimeEntries />}
        { this.state.selected=='profile' && <ViewProfile />}
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(UserModule);



// WEBPACK FOOTER //
// ./src/user/UserModule.js